var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoachingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd",
    opacity: 0.499
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.16 2.276a1.08 1.08 0 011.078-1.078h10.865v6.776a1.08 1.08 0 01-1.079 1.078h-7.01c-.57 0-1.119.176-1.584.508l-2.27 1.62V2.276zM0 12.306a.58.58 0 00.916.471l3.188-2.274a1.56 1.56 0 01.91-.291h7.01a2.24 2.24 0 002.238-2.238V.618a.58.58 0 00-.58-.58H2.238A2.24 2.24 0 000 2.277v10.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.787 6.773a2.24 2.24 0 00-2.237-2.238H16a.58.58 0 000 1.16h1.549a1.08 1.08 0 011.078 1.078v8.903l-2.27-1.62a2.712 2.712 0 00-1.585-.507h-7.01a1.08 1.08 0 01-1.078-1.079v-.52a.58.58 0 00-1.16 0v.52a2.24 2.24 0 002.238 2.238h7.01c.329 0 .644.101.91.292l3.188 2.273a.58.58 0 00.916-.471V6.772zM4.169 4.356h6.697a.58.58 0 000-1.16H4.17a.58.58 0 000 1.16M4.169 7.061h6.697a.58.58 0 000-1.16H4.17a.58.58 0 000 1.16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachingIcon);
export default __webpack_public_path__ + "static/media/coaching-icon.a3d56169.svg";
export { ForwardRef as ReactComponent };